import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { DataSearch, SearchBox } from '../../Components/SearchBox/SearchBox'
import { Template } from '../../Components/Template/template'
import {
    classDivBackground, classDivBody, classInput, classInputDark, classLabel, classLabelDark, classBt, classbtAzul, AlertType, Caixa, classBorderLabelDark,
    classWeigthBt, classbtCinzaClaro, barraVermelhoAzul, bgBlue, bgRed, InputsRefs,
    CaixaTransferencia
} from '../../Utils/Types'
import { FaMoneyBillTransfer } from 'react-icons/fa6'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faFolder } from '@fortawesome/free-solid-svg-icons'
import { Funcoes } from '../../Utils/Funcoes'
import { LanctoCaixaService } from './LanctoCaixaService'
import moment from 'moment'
import { AiOutlineClear } from 'react-icons/ai'
import { Tooltip } from 'react-tooltip'
import { FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'




export const TransferenciasPage = () => {

    // -----------------------------------------------
    // ----------------- TABS ------------------------
    // -----------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        //{ index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // -----------------------------------------------
    // ------------------ ATRIBUTOS ------------------
    // -----------------------------------------------
    let date = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    //const [idCaixa, setIdCaixa] = useState(0)

    const [valor, setValor] = useState("0.00")
    const [data, setData] = useState(date)
    const [historico, setHistorico] = useState("")
    const [contas, setContas] = useState<DataSearch[]>([])
    //const [tipo, setTipo] = useState("")

    // CONTA DEBITO
    const [idContaDebito, setIdContaDebito] = useState(0)
    const [contasFilterDebito, setContasFilterDebito] = useState<DataSearch[]>([])

    // CONTA CREDITO
    const [idContaCredito, setIdContaCredito] = useState(0)
    const [contasFilterCredito, setContasFilterCredito] = useState<DataSearch[]>([])

    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [loading, setLoading] = useState(false)
    const [feedbackVisible, setFeedbackVisible] = useState(false)
    const [feedbackMessage, setFeedbackMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    //const [windowHeight, setWindowHeight] = useState(0)

    // -----------------------------------------------
    // ------------------ SEARCHBOX ------------------
    // -----------------------------------------------
    const [visibleSearchBoxContaDebito, setVisibleSearchBoxContaDebito] = useState<boolean>(false)
    const [visibleSearchBoxContaCredito, setVisibleSearchBoxContaCredito] = useState<boolean>(false)

    // -----------------------------------------------
    // ---------- ATRIBUTOS TUTORIAL -----------------
    // -----------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    //----------------------------------------------------------------------------------------- ATTRIBUTES E EFFECT -------------------------------------------------------------- ||
    const GetAttibutes = async () => {
        setLoading(true)

        try {

            const listaCaixa = await LanctoCaixaService.GetAttributes()

            setContas(listaCaixa.data)
            setContasFilterDebito(listaCaixa.data)
            setContasFilterCredito(listaCaixa.data)

        } catch (error) {

            setFeedbackVisible(true)
            setMessageType("DANGER")
            setFeedbackMessage("Não foi possível buscar as contas")

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        //setWindowHeight(window.innerHeight * 0.75)
        GetAttibutes()
        Inputfocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }

        Inputfocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
    }


    //------------------------------------------------------------------------------------------------------ INPUTS --------------------------------------------------------------------------- ||
    const handleChangeValor = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeData = (e: React.ChangeEvent<HTMLInputElement>) => {
        setData(e.target.value)
    }

    const handleChangeHistorico = (e: React.ChangeEvent<HTMLInputElement>) => {
        setHistorico(e.target.value)
    }

    /*
    const handleChangeTipo = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo(e.target.value)
    }
    */

    //------------------------------------------------------------------------------------------------------ CONTA DEBITO --------------------------------------------------------------------------- ||
    const handleClearContaDebitoSelecionada = useCallback(() => {
        let newContas = [...contas]
        setContasFilterDebito(newContas)
        setIdContaDebito(0)

        setVisibleSearchBoxContaDebito(false)
        boxFocusContaDebito()

    }, [contas])

    const handleSetContaDebitoClick = useCallback((conta: DataSearch) => {

        if (conta) {
            let newContas = [...contas]
            setContasFilterDebito(newContas)
            setIdContaDebito(conta.id)

            if (conta.id === idContaCredito) {
                setIdContaCredito(0)
            }
        }

        setVisibleSearchBoxContaDebito(false)
        boxFocusContaDebito()

    }, [contas, idContaCredito])

    const handleFilterContaDebitoClick = useCallback((description: string) => {
        let newContas = [...contas]

        if (description !== "") {
            newContas = newContas.filter((conta) => conta.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()))
            setContasFilterDebito(newContas)
        } else {
            setContasFilterDebito(contas)
        }

    }, [contas])

    //------------------------------------------------------------------------------------------------------ CONTA CREDITO --------------------------------------------------------------------------- ||
    const handleClearContaCreditoSelecionada = useCallback(() => {
        let newContas = [...contas]
        setContasFilterCredito(newContas)
        setIdContaCredito(0)

        setVisibleSearchBoxContaCredito(false)
        boxFocusContaCredito()

    }, [contas])

    const handleSetContaCreditoClick = useCallback((conta: DataSearch) => {

        if (conta) {
            let newContas = [...contas]
            setContasFilterCredito(newContas)
            setIdContaCredito(conta.id)

            if (conta.id === idContaDebito) {
                setIdContaDebito(0)
            }
        }

        setVisibleSearchBoxContaCredito(false)
        boxFocusContaCredito()

    }, [contas, idContaDebito])

    const handleFilterContaCreditoClick = useCallback((description: string) => {

        if (description === "") {

            const newContas = [...contas]
            setContasFilterCredito(newContas)

        } else {

            const newContas = [...contas || []].filter((conta) => {
                return conta.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setContasFilterCredito(newContas || [])
        }
    }, [contas])

    //------------------------------------------------------------------------------------------------------ TRANSFERENCIAS --------------------------------------------------------------------------- ||
    const handleNovoLanctoClick = () => {
        setData(date)
        setValor("0.00")
        setHistorico("")
        setIdContaDebito(0)
        setIdContaCredito(0)
        //setTipo("")

        handleInputFocus()
        Inputfocus()

        if (messageType === 'DANGER') {
            setFeedbackVisible(false)
        }
    }

    const handleSaveClick = async () => {

        setFeedbackVisible(false)
        setLoading(true)

        try {

            handleInputFocus()
            Inputfocus()

            const transfereciaCaixa: CaixaTransferencia = {
                idContaOrigem: idContaDebito,
                idContaDestino: idContaCredito,
                valor: parseFloat(valor),
                historico: historico,
                data: data,
            }

            const retAPI = await LanctoCaixaService.Transferencia(transfereciaCaixa)

            if (retAPI.error) {
                setFeedbackVisible(true)
                setMessageType("DANGER")
                setFeedbackMessage(retAPI.msg || "")
                return
            }

            setData(date)
            setValor("0.00")
            setHistorico("")
            setIdContaDebito(0)
            setIdContaCredito(0)
            //setTipo("")

            setFeedbackVisible(true)
            setMessageType("SUCCESS")
            setFeedbackMessage("Transferência efetuada com sucesso")

        } catch (error) {

            setFeedbackVisible(true)
            setMessageType("DANGER")
            setFeedbackMessage("Houve um erro na transferência. Por favor, tente novamente")

        } finally {
            setLoading(false)
        }
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("data")
        inputElement?.focus()
    }

    const handleCloseFeedbackMessage = () => {
        setFeedbackVisible(false)
    }

    // ---------------------------------------------------------------- FOCUS ABA 1 -----------------------------------------------------------------
    const inputsRefs: InputsRefs = {
        data: useRef(null),
        contaDebito: useRef(null),
        contaCredito: useRef(null),
        valor: useRef(null),
        historico: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            handleInputFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 1) {
                setVisibleSearchBoxContaDebito(true)
                inputFocusContaDebito()
            }

            if (nextIndex === 2) {
                setVisibleSearchBoxContaCredito(true)
                inputFocusContaCredito()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab') {

                event.preventDefault()

                const inputSearchContaDebito = document.getElementById('inputSearchBox-contaDebito') as HTMLInputElement
                const inputSearchContaCredito = document.getElementById('inputSearchBox-contaCredito') as HTMLInputElement

                if (document.activeElement === inputSearchContaDebito) {

                    clickSearchBoxContaCredito()
                    setVisibleSearchBoxContaDebito(false)

                } else if (document.activeElement === inputSearchContaCredito) {
                    inputsRefs['valor'].current?.focus()
                    setVisibleSearchBoxContaCredito(false)
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [])

    const handleInputFocus = () => {
        setVisibleSearchBoxContaDebito(false)
        setVisibleSearchBoxContaCredito(false)
    }

    // CONTA DEBITO
    const boxFocusContaDebito = () => {
        // Move o foco para o input correspondente à chave 'contaDebito'.
        inputsRefs['contaDebito'].current?.focus()
    }

    const clickSearchBoxContaDebito = useCallback(() => {
        setVisibleSearchBoxContaDebito((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxContaCredito(false)
                inputFocusContaDebito()
            }
            return newState;
        })
        boxFocusContaDebito()
    }, [])

    const inputFocusContaDebito = () => {
        let inputSearch = document.getElementById(`inputSearchBox-contaDebito`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // CONTA CREDITO
    const boxFocusContaCredito = () => {
        // Move o foco para o input correspondente à chave 'contaCredito'.
        inputsRefs['contaCredito'].current?.focus()
    }

    const clickSearchBoxContaCredito = useCallback(() => {
        setVisibleSearchBoxContaCredito((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxContaDebito(false)
                inputFocusContaCredito()
            }
            return newState
        });
        boxFocusContaCredito()
    }, [])

    const inputFocusContaCredito = () => {
        let inputSearch = document.getElementById(`inputSearchBox-contaCredito`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={feedbackVisible} message={feedbackMessage} type={messageType} onCloseMessage={handleCloseFeedbackMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`min-h-[50px] w-full flex flex-col sm:flex-row items-center py-3 px-2 space-y-2 sm:space-y-0 sm:space-x-2 border border-x-0 border-t-0 border-slate-300 dark:border-slate-700`}>

                            <div className={`flex flex-row items-center`}>
                                <FaMoneyBillTransfer className={`ml-2 mr-2 text-slate-700 dark:text-slate-200`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 whitespace-nowrap`}>Transferências</span>
                            </div>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} h-9 shadow-md shadow-blue-600`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`relative`}>

                                <div className={`flex flex-col sm:flex-row`}>

                                    <div className={`w-full grid gap-5 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <div className={`flex flex-row `}>
                                                <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados da Transferência</span>
                                                <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 `} size={18} />
                                                <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                    <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                                </Tooltip>
                                            </div>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-3 xl:col-span-2`}>

                                            <div className={`${barraVermelhoAzul} ${data != "" ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.data} onKeyDown={(e) => handleTabPress(e, 'data')} id="data" className={`${classInput} ${classInputDark} ${data == '' ? 'text-blue-500 dark:text-cyan-300' : ''} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " disabled={true} value={data} onFocus={handleInputFocus} onChange={handleChangeData} />
                                            <label htmlFor="data" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-9 xl:col-span-4`}>

                                            <div ref={inputsRefs['contaDebito']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'contaDebito')} />
                                            <div className={`${barraVermelhoAzul} ${idContaDebito > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={contasFilterDebito}
                                                idRegistro={idContaDebito}
                                                label='Conta Debitada'
                                                componentId='contaDebito'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxContaDebito}
                                                setDataClick={handleSetContaDebitoClick}
                                                clearDataClick={handleClearContaDebitoSelecionada}
                                                filterDataClick={handleFilterContaDebitoClick}
                                                clicado={clickSearchBoxContaDebito}

                                            />
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-9 xl:col-span-4`}>

                                            <div ref={inputsRefs['contaCredito']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'contaCredito')} />
                                            <div className={`${barraVermelhoAzul} ${idContaCredito > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={contasFilterCredito}
                                                idRegistro={idContaCredito}
                                                label='Conta Creditada'
                                                componentId='contaCredito'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxContaCredito}
                                                setDataClick={handleSetContaCreditoClick}
                                                clearDataClick={handleClearContaCreditoSelecionada}
                                                filterDataClick={handleFilterContaCreditoClick}
                                                clicado={clickSearchBoxContaCredito}

                                            />
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-3 xl:col-span-2`}>

                                            <div className={`${barraVermelhoAzul} ${parseFloat(valor) > 0 ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.valor} onKeyDown={(e) => handleTabPress(e, 'valor')} id="valor" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={valor} onFocus={handleInputFocus} onChange={handleChangeValor} />
                                            <label htmlFor="valor" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor</label>
                                        </div>

                                        <div className={`relative col-span-12 md:col-span-9 xl:col-span-10`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.historico} onKeyDown={(e) => handleTabPress(e, 'historico')} id="historico" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' placeholder=" " value={historico} onFocus={handleInputFocus} onChange={handleChangeHistorico} />
                                            <label htmlFor="historico" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Histórico</label>
                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    {/*
                                    <Link onMouseUp={handleMouseUp} to="/contaApagar" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>
                                    */}

                                    <button tabIndex={-1} onClick={handleNovoLanctoClick} className={`${classBt} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveClick} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <FaMoneyBillTransfer size="20px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {!loading ? `Tranferir` : `Aguarde`}

                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_transferenciaConta.mp4'
                            title='Como fazer uma transferência entre contas'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>
    )
}